export default __webpack_public_path__ + "static/1.1_IT-558ebdc70e9b58414a2ed1d238808622.webp";